import { userApi } from '../../../api';

export type OtpValidateParams = {
	otp: string;
	email: string;
	auth?: boolean;
};

export type OtpValidateResponse = {
	active: boolean;
	creation: string;
	email: string;
	expiration: string;
	lastAccess: string;
	name: string;
	source: number;
	status: string;
	token?: string;
	userId?: number;
};

export type OtpSendParams = {
	path?: string;
	resend?: boolean;
};

export type OtpSendResponse = {
	millisecondsRemaining?: number | null;
};

export const postOtpValidate = (params: OtpValidateParams) => {
	const payload = {
		otp: params.otp,
		email: params.email,
	};
	const url = params.auth === true 
		? '/user/otp/validate?auth=true'
		: '/user/otp/validate';
	
	return userApi
		.post<OtpValidateResponse>(url, payload)
		.then(res => res.data);
};

export const postOtpSend = (params: OtpSendParams) => {
	const payload: { path?: string } = {};
	if (params.path) {
		payload.path = params.path;
	}
	const url = params.resend === true
		? '/user/otp/send?resend=true'
		: '/user/otp/send';
	
	return userApi
		.post<OtpSendResponse>(url, payload)
		.then(res => res.data);
};
